import React from 'react';
import { Row, Col } from 'antd';
import Layout from '../Layout';
import UserStatistics from "./UserStatistics";
import PlaceStatistics from "./PlaceStatistics";
import CardsStatistics from "./CardsStatistics";

export default function Dashboard() {
  return (
    <Layout>
      <Row gutter={16}>
        <Col span={8}>
          <UserStatistics />
        </Col>
        <Col span={8}>
          <PlaceStatistics/>
        </Col>
        <Col span={8}>
          <CardsStatistics />
        </Col>
      </Row>
    </Layout>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js